module.exports = __webpack_public_path__ + "img/collapse-icon.ccde0870.svg";